export const getBiToken = (instance, platformAPIs) => {
  try {
    const [, data] = instance.split('.');
    return JSON.parse(atob(data)).biToken;
  } catch (e) {
    return platformAPIs.bi.metaSiteId;
  }
};
